(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bene-customer-gate"]) return;
  try {
    
  /**
   * BeneCustomerGate
   *
   * A modal that is deliberately not dismissable: no close button, no overlay
   * click, no Escape. The only ways out are the choices themselves, all of
   * which navigate away. Interaction with the page behind it is blocked by
   * marking every other top-level element inert.
   */
  class BeneCustomerGate extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
    }

    connectedCallback() {
      this.loginUrl = this.getAttribute('data-login-url') || '/account/login';
      this.chFallback = this.getAttribute('data-ch-fallback') || 'https://www.beneganic.ch/';
      this.steps = {
        type: this.querySelector('[data-step="type"]'),
        region: this.querySelector('[data-step="region"]'),
      };

      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown, true);
      document.addEventListener('focusin', this.onFocusIn, true);

      document.documentElement.classList.add('customer-gate-open');
      this.setBackgroundInert(true);

      /* Cookie banners, review badges and marketing popups are appended to the
         body long after this element connects, so inerting once is not enough. */
      this.observer = new MutationObserver(() => this.setBackgroundInert(true));
      this.observer.observe(document.body, { childList: true });

      this.focusStep();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('keydown', this.onKeydown, true);
      document.removeEventListener('focusin', this.onFocusIn, true);
      document.documentElement.classList.remove('customer-gate-open');
      this.setBackgroundInert(false);
    }

    /* The section wrapper Shopify puts around us, or us if there is none. */
    get root() {
      return this.closest('.shopify-section') || this;
    }

    setBackgroundInert(inert) {
      const root = this.root;
      const skip = ['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE', 'NOSCRIPT'];
      Array.from(document.body.children).forEach((el) => {
        if (el === root || skip.includes(el.tagName)) return;
        if (inert) {
          if (!el.hasAttribute('inert')) el.setAttribute('inert', '');
        } else {
          el.removeAttribute('inert');
        }
      });
    }

    /* Focus the dialog itself, not the first card — auto-focusing a card makes
       that option look pre-selected, and this is what announces the dialog. */
    focusStep() {
      this.focus({ preventScroll: true });
    }

    visibleButtons() {
      return Array.from(this.querySelectorAll('button')).filter((el) => !el.closest('[hidden]'));
    }

    /* Escape must not dismiss the gate, and Tab must not leave it. */
    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = this.visibleButtons();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (document.activeElement === this) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    onFocusIn(event) {
      if (!this.contains(event.target)) this.focusStep();
    }

    onClick(event) {
      const trigger = event.target.closest('[data-action]');
      if (!trigger || !this.contains(trigger)) return;

      switch (trigger.getAttribute('data-action')) {
        case 'to-ch':
          this.goToSwissStore();
          break;
        case 'show-region':
          this.showStep('region');
          break;
        case 'back':
          this.showStep('type');
          break;
        case 'to-login':
          window.location.href = this.loginUrl;
          break;
      }
    }

    showStep(name) {
      this.steps.type.hidden = name !== 'type';
      this.steps.region.hidden = name !== 'region';
      /* Otherwise the dialog keeps announcing step 1's heading on step 2. */
      this.setAttribute('aria-labelledby', name === 'region' ? 'customer-gate-title-region' : 'customer-gate-title');
      this.focusStep();
    }

    /**
     * beneganic.ch is a separate Shopify store: some handles moved and a few
     * collide, so the path is resolved through the generated map. If the map
     * has not loaded, the homepage is the safe answer.
     */
    goToSwissStore() {
      let target = this.chFallback;
      if (typeof window.beneganicResolveChUrl === 'function') {
        try {
          target = window.beneganicResolveChUrl(window.location.pathname);
        } catch (error) {
          console.error('Customer gate: could not resolve the .ch URL', error);
        }
      }
      window.location.href = target;
    }
  }

  if (!customElements.get('bene-customer-gate')) {
    customElements.define('bene-customer-gate', BeneCustomerGate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bene-pdp-active-ingredients"] && !Shopify.designMode) return;
  try {
    
  class BenePdpActiveIngredients extends HTMLElement {
    constructor() {
      super();
      this.sidebar = this.querySelector('[data-sidebar]');
      this.expandedTab = this.querySelector('[data-expanded-tab]');
      this.close = this.querySelector('[data-close]');
      this.slideCards = this.querySelectorAll('[data-slide-card]');
      this.expandedCards = this.querySelectorAll('[data-expanded-card]');
      this.initSidebar();
    }

    initSidebar() {
      this.slideCards.forEach((card, index) => {
        card.addEventListener('click', () => {
          this.sidebar.toggleAttribute('data-active');
          document.body.style.overflow = 'hidden';
          setTimeout(() => {
            this.expandedTab.toggleAttribute('data-active');
            this.expandedCards[index].toggleAttribute('data-active');
          }, 200);
        });
      });

      this.close ?. addEventListener('click', () => this.closeSidebar());
      this.sidebar ?. addEventListener('click', (event) => {
        if (event.target === this.sidebar) 
          this.closeSidebar();
        


      });
    }

    closeSidebar() {
      this.sidebar.removeAttribute('data-active');
      this.expandedTab.removeAttribute('data-active');
      this.expandedCards.forEach((card) => card.removeAttribute('data-active'));
      document.body.style.overflow = '';
    }
  }

  customElements.define('bene-pdp-active-ingredients', BenePdpActiveIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bene-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
    class BenePdpIngredients extends HTMLElement {
        constructor() {
            super();

            this.sidebar = this.querySelector('[data-sidebar]');
            this.expandedTab = this.querySelector('[data-expanded-tab]');
            this.close = this.querySelector('[data-close]');

            this.slideCards = this.querySelectorAll('[data-slide-card]');
            this.expandedCards = this.querySelectorAll('[data-expanded-card]');

            this.initSidebar();
        }

        initSidebar() {
            this.slideCards.forEach((card, index) => {
                card.addEventListener('click', () => {
                    console.log('Card clicked:', index);
                    this.sidebar.toggleAttribute('data-active');
                    document.body.style.overflow = 'hidden'; // Prevent scrolling when sidebar is open
                    setTimeout(() => {
                        this.expandedTab.toggleAttribute('data-active');
                        this.expandedCards[index].toggleAttribute(
                            'data-active',
                        );
                    }, 200);
                });
            });

            this.close?.addEventListener('click', () => {
                this.closeSidebar();
            });

            this.sidebar?.addEventListener('click', (event) => {
                if (event.target === this.sidebar) {
                    this.closeSidebar();
                }
            });
        }

        closeSidebar() {
            this.sidebar.removeAttribute('data-active');
            this.expandedTab.removeAttribute('data-active');
            this.expandedCards.forEach((card) =>
                card.removeAttribute('data-active'),
            );
            document.body.style.overflow = ''; // Restore scrolling when sidebar is closed
        }
    }

    customElements.define('bene-pdp-ingredients', BenePdpIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bene-testimonial"] && !Shopify.designMode) return;
  try {
    
    class BeneTestimonialContent extends HTMLElement {
        constructor() {
            super();

            this.content = this.querySelector('.testimonial-card__description');
            this.button = this.querySelector('button');

            this.button.addEventListener('click', () => {
                const contentShown = this.dataset.expanded === 'true';
                this.setAttribute(
                    'data-expanded',
                    contentShown ? 'false' : 'true',
                );
            });
        }
    }
    customElements.define('bene-testimonial-content', BeneTestimonialContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-switcher"] && !Shopify.designMode) return;
  try {
    
  /**
   * StoreSwitcher - Custom HTML Element
   *
   * Handles the behavior of the store switcher popup including:
   * - Geo-location detection
   * - Conditional visibility based on user location and domain
   * - One-time display with localStorage persistence
   * - Smart redirection only when needed
   */
  class StoreSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.shouldShow = JSON.parse(this.getAttribute('data-should-show') || 'false');
      this.devMode = JSON.parse(this.getAttribute('data-dev-mode') || 'false');
      this.currentDomain = window.location.hostname;

      this.attachEventListeners();
      // Check visibility after a small delay to ensure DOM is fully ready
      setTimeout(() => this.checkVisibility(), 10);
    }

    async getUserCountry() {
      try {
        const response = await fetch("https://ipinfo.io/json?token=c86425d56ba631");
        const data = await response.json();
        return data.country || '';
      } catch (error) {
        console.error('Error fetching location:', error);
        return null;
      }
    }

    attachEventListeners() {
      const closeButton = this.querySelector('.store-switcher__close-button');
      const overlay = this.querySelector('.store-switcher__overlay');
      const storeButtons = this.querySelectorAll('.store-switcher__button');

      if (closeButton) {
        closeButton.addEventListener('click', () => this.close());
      }

      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      if (storeButtons) {
        storeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            const targetDomain = button.getAttribute('data-store-domain');
            const storeType = button.getAttribute('data-store-type');
            const currentDomain = window.location.hostname;

            // Only redirect if the user is on a different domain than the one they selected
            if ((storeType === 'ch' && !currentDomain.includes('beneganic.ch')) ||
                (storeType === 'eu' && !currentDomain.includes('beneganic.com'))) {
              window.location.href = targetDomain;
            } else {
              // Just close the popup if they're already on the right domain
              this.close();
            }
          });
        });
      }
    }

    close() {
      this.classList.remove('active');
      // Mark that the user has seen the popup
      localStorage.setItem('store_switcher_opened', 'true');
    }

    async checkVisibility() {
      // In dev mode, always show the popup
      if (this.devMode) {
        this.classList.add('active');
        return;
      }

      // Check if the modal should be shown based on localStorage
      const hasOpenedBefore = localStorage.getItem('store_switcher_opened') === 'true';

      // Don't show if it's been opened before
      if (hasOpenedBefore) {
        this.classList.remove('active');
        return;
      }

      // Check user's country
      const userCountry = await this.getUserCountry();
      if(userCountry == null) {
        return;
      }
      const isUserInSwitzerland = userCountry === 'CH';

      // Determine if we should show the popup based on domain and location
      let shouldShowBasedOnGeo = false;

      if (this.currentDomain.includes('beneganic.com') && isUserInSwitzerland) {
        // Case A: User is on .com but is in Switzerland
        shouldShowBasedOnGeo = true;
      } else if (this.currentDomain.includes('beneganic.ch') && !isUserInSwitzerland) {
        // Case B: User is on .ch but is not in Switzerland
        shouldShowBasedOnGeo = true;
      }

      // Show the modal if geo conditions are met and it's enabled in settings
      if (shouldShowBasedOnGeo && this.shouldShow) {
        this.classList.add('active');
        // Mark that we've shown the popup to this user
        localStorage.setItem('store_switcher_opened', 'true');
      } else {
        this.classList.remove('active');
      }
    }

    // Add a public method to open the popup manually if needed
    open() {
      this.classList.add('active');
    }

    // Add a method to reset the popup state (for testing)
    reset() {
      localStorage.removeItem('store_switcher_opened');
      this.checkVisibility();
    }
  }

  // Define the custom element
  if (!customElements.get('store-switcher')) {
    customElements.define('store-switcher', StoreSwitcher);
  }

// Make the store-switcher element accessible globally
window.storeSwitcherAPI = {
  open: function() {
    const storeSwitcher = document.getElementById('store-switcher');
    if (storeSwitcher) {
      storeSwitcher.open();
    }
  },
  reset: function() {
    const storeSwitcher = document.getElementById('store-switcher');
    if (storeSwitcher) {
      storeSwitcher.reset();
    }
  }
};

  } catch(e) { console.error(e); }
})();
})();
